<template>
  <v-row>
    <v-col cols="12" md="6" class="pb-0">
      <gg-text-field
        v-model="keyData.name"
        label="Key Name"
        name="Key Name"
        v-validate="'required'"
        :error-messages="errors.collect('Key Name')"
      />
    </v-col>
    <v-col cols="12" md="6" class="pb-0">
      <gg-text-field
        v-model="keyData.pass"
        label="Passphrase"
        :type="passVisible ? 'text' : 'password'"
        :append-icon="passVisible ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="togglePassVisibility"
      />
    </v-col>
    <v-col cols="12" class="py-0">
      <v-textarea
        outlined
        v-model="keyData.key"
        name="Key"
        label="Key"
        rows="7"
        no-resize
        v-validate="'required'"
        :error-messages="errors.collect('Key')"
      />
    </v-col>
    <v-col cols="12" class="pt-0">
      <gg-btn
        class="ml-0"
        tile
        :loading="loading"
        @click="importKey"
      >
        Import Key
      </gg-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ImportKeyForm',
  data () {
    return {
      keyData: {
        name: '',
        pass: '',
        key: ''
      },
      loading: false,
      passVisible: false,
    }
  },
  methods: {
    ...mapActions(['importHostingSshKey', 'reportError', 'reportSuccess']),
    togglePassVisibility () {
      this.passVisible = !this.passVisible
    },
    reset () {
      this.keyData.name = ''
      this.keyData.pass = ''
      this.keyData.key = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    async importKey () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.loading = true
      try {
        const response = await this.importHostingSshKey({
          ...this.keyData,
          _username: this.$route.query.user,
        })
        this.reportSuccess(`The key named “${response[0].name || ''}” was imported.`)
        this.reset()
        this.$emit('reload-tables', {
          privateTable: true,
          publicTable: true
        })
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  },
}
</script>
